<template>
<div
  v-if="showSplashScreen"
  :class="['splash-screen', 'flex', 'items-center', 'justify-center', 'min-h-screen', 'bg-white', { 'animate-fade-out': fadeOut }]"
>
  <div class="text-center animate-fade-in-up">
    <h1 class="text-5xl font-bold mb-8 animate-bounce">Bienvenue</h1>
    <button
      @click="handleButtonClick"
      class="px-6 py-3 text-lg font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-all duration-200"
    >
     Enregistrez Vous
    </button>
  </div>
</div>


    <div v-else class="appointment-container flex items-center justify-center min-h-screen"> <!-- Flexbox pour centrer -->
      <div 
        class="absolute inset-0 bg-cover bg-center z-0"
        style=" max-height: 400px; background-image: url('https://img.freepik.com/free-photo/bowl-with-fruits-breakfast-with-clipboard-beside_23-2148571053.jpg?t=st=1730474276~exp=1730477876~hmac=8da195e1dfdab500c91f327aa02251254094d8fb94a48580bda65d78f684e712&w=2000');"
      ></div>
<transition name="slide-fade">
  <div
    v-if="success"
    class="fixed inset-0 bg-white flex items-center justify-center z-50"
  >
    <div class="text-center animate-bounce">
      <p class="text-4xl font-bold text-green-600 leading-snug">
        Rendez-vous réservé avec succès !<br />
        <span class="text-2xl font-medium text-gray-700">
          Votre rendez-vous s'affichera dans la salle d'attente.
        </span>
      </p>
    </div>
  </div>
</transition>


      <div class="relative bg-white shadow-2xl rounded-2xl overflow-hidden min-w-[400px] md:min-w-[500px] lg:min-w-[600px]"> <!-- Supprimé 'mx-auto' -->
        <div class="relative z-10 p-8 bg-gradient-to-br from-white via-gray-50 to-gray-100 bg-opacity-80">
          <h1 class="text-3xl font-semibold text-center mb-8 text-gray-800">ENREGISTREZ VOUS</h1>
  
          <!-- Formulaire de réservation -->
          <form @submit.prevent="bookAppointment" class="grid grid-cols-1 gap-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6"> <!-- Changement ici -->
              <!-- Colonne de gauche -->
              <div>
                <div>
                  <label for="firstName" class="block text-gray-600 font-medium">Prénom:</label>
                  <input
                    v-model="appointment.firstName"
                    type="text"
                    id="firstName"
                    required
                    autocomplete="off"
                    class="input-field border border-gray-300 focus:ring focus:ring-blue-400 focus:outline-none rounded-lg p-2 w-full"
                  />
                </div>
  
                <div class="mt-4">
                  <label for="lastName" class="block text-gray-600 font-medium">Nom:</label>
                  <input
                    v-model="appointment.lastName"
                    type="text"
                    id="lastName"
                    required
                    autocomplete="off"
                    class="input-field border border-gray-300 focus:ring focus:ring-blue-400 focus:outline-none rounded-lg p-2 w-full"
                  />
                </div>
  
                <div class="mt-4">
                  <label for="phoneNumber" class="block text-gray-600 font-medium">Téléphone:</label>
                  <input
                    v-model="appointment.phoneNumber"
                    type="tel"
                    id="phoneNumber"
                    required
                    autocomplete="off"
                    class="input-field border border-gray-300 focus:ring focus:ring-blue-400 focus:outline-none rounded-lg p-2 w-full"
                  />
                </div>
  
              </div>
  
              <!-- Colonne de droite -->
              <div>
  <div>
    <label for="date" class="block text-gray-600 font-medium">Date:</label>
    <select
      v-model="appointment.date"
      id="date"
      required
      autocomplete="off"
      class="input-field border border-gray-300 focus:ring focus:ring-blue-400 focus:outline-none rounded-lg p-2 w-full mt-4"
      @change="updateAvailableSlots"
    >
      <option value="" disabled>Select a date</option> <!-- Option par défaut -->
      <option :value="currentDate">{{ currentDate }}</option>
      <option :value="tomorrowDate">{{ tomorrowDate }}</option>
    </select>
  </div>

  <div class="mt-4" v-if="appointment.date">
  <label class="block text-gray-600 font-medium">Créneau horaire:</label>
  <ul id="timetable" class="grid w-full grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 mt-5">
    <li v-for="(slot) in displayedSlots" :key="slot">
      <input type="radio" :id="slot" :value="slot" class="hidden peer" name="timetable" @change="updateTimeSlot(slot)">
      <label :for="slot"
        class="inline-flex items-center justify-center w-full p-2 text-sm font-medium text-center bg-white border rounded-lg cursor-pointer text-blue-600 border-blue-600 peer-checked:bg-blue-600 peer-checked:text-white hover:bg-blue-500">
        {{ slot }}
      </label>
    </li>
  </ul>

  <!-- Bouton pour charger 20 créneaux supplémentaires -->
  <div class="flex justify-center mt-4" v-if="displayedSlots.length < availableSlots.length">
    <button @click="loadMoreSlots" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700">
      Afficher 20 de plus
    </button>
  </div>
</div>

</div>

            </div>
  
            <button
              type="submit"
              class="mt-6 col-span-1 w-full bg-blue-600 text-white font-semibold py-3 rounded-lg shadow-md hover:bg-blue-700 transition-all duration-200 transform hover:scale-105"
            >
              Réserver
            </button>
          </form>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        showSplashScreen: true,
        fadeOut: false, // Affiche le splash screen au chargement
        success: false,
        availableSlots: [],
        appointment: {
          firstName: "",
          lastName: "",
          phoneNumber: "",
          age: '1',
          date: "",
          timeSlot: "",
        },
        currentDate: "",
        tomorrowDate: "",
        initialSlotCount: 20, // Nombre initial de créneaux affichés
        displayedSlotsCount: 20, // Nombre de créneaux actuellement affichés
      };
    },
    async created() {
      await this.getAvailableSlots();
    },
    computed: {
  displayedSlots() {
    // Limite l'affichage des créneaux au nombre actuel souhaité
    return this.availableSlots.slice(0, this.displayedSlotsCount);
  }
},
methods: {
  handleButtonClick() {
      // Ajouter l'animation de fade-out
      this.fadeOut = true;
      // Attendre la fin de l'animation avant de masquer l'écran
      setTimeout(() => {
        this.showSplashScreen = false;
        this.enterPage();
      }, 500); // La durée doit correspondre à celle définie en CSS pour l'animation
    },
  enterPage() {
      this.showSplashScreen = false;
       // Cache le splash screen
      this.getAvailableSlots()
    },
  loadMoreSlots() {
    // Augmente le nombre de créneaux affichés de 20
    this.displayedSlotsCount += 20;
  },
        updateTimeSlot(slot) {
      this.appointment.timeSlot = slot; // Met à jour le timeSlot avec le créneau sélectionné
      console.log('Créneau horaire sélectionné:', this.appointment.timeSlot); // Pour le débogage
    },
      async getAvailableSlots() {
        try {
          const response = await fetch("https://thierry-paradis-medecin-743b8e1c5de0.herokuapp.com/available-slots-today");
         //  const response = await fetch("http://localhost:3000/available-slots-today");
          const data = await response.json();
          this.currentDate = new Date().toISOString().split("T")[0];
          const tomorrow = new Date();
          tomorrow.setDate(new Date().getDate() + 1);
          this.tomorrowDate = tomorrow.toISOString().split("T")[0];
          this.availableSlots = [...data.tomorrow];
        } catch (error) {
          console.error("Erreur lors de la récupération des créneaux :", error);
        }
      },
      async updateAvailableSlots() {
  const selectedDate = this.appointment.date === this.currentDate ? 'today' : 'tomorrow';
  try {
    const response = await fetch(`https://thierry-paradis-medecin-743b8e1c5de0.herokuapp.com/available-slots-today`);
    const data = await response.json();

    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    if (selectedDate === 'today') {
      // Filtrer pour ne conserver que les créneaux après l'heure actuelle
      this.availableSlots = data[selectedDate].filter(slot => {
        const [slotHour, slotMinute] = slot.split(':').map(Number);
        return slotHour > currentHour || (slotHour === currentHour && slotMinute >= currentMinute);
      });
    } else {
      // Si c'est pour demain, afficher tous les créneaux
      this.availableSlots = data[selectedDate];
    }
  } catch (error) {
    console.error("Erreur lors de la récupération des créneaux :", error);
  }
}
,
async bookAppointment() {
  try {
    const response = await fetch(
      "https://thierry-paradis-medecin-743b8e1c5de0.herokuapp.com/book-appointment",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.appointment),
      }
    );

    if (response.ok) {
  this.success = true;
  this.resetForm();

  // Attendre 3 secondes avant de cacher le message de succès
  setTimeout(() => {
    this.success = false;

    // Afficher le splash screen après le message de confirmation
    this.showSplashScreen = true;
    this.fadeOut = false; // Réinitialiser l'animation du splash screen
    location.reload(); // Cela va recharger la page
    // Attendre 5 secondes avant de faire disparaître le splash screen
  
    
  }, 6000); // Temps d'affichage du message de confirmation (3 secondes)
}
 else {
      console.error("Erreur lors de la réservation");
    }
  } catch (error) {
    console.error("Erreur lors de la réservation :", error);
  }
}
,
      resetForm() {
        this.appointment = {
          firstName: "",
          lastName: "",
          phoneNumber: "",
          age: null,
          date: "",
          timeSlot: "",
        };
        this.availableSlots = [];
      },
    },
  };
  </script>
  
  <style>
  .splash-screen {
  background-color: #ffffff;
}
  .input-field {
    display: block;
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    background: white;
    transition: border-color 0.2s;
  }
  .input-field:focus {
    border-color: #3b82f6;
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
  
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.5s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(-20px);
    opacity: 0;
  }

  /* Animation Fade-in et Scale-up */
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.animate-fade-in-up {
  animation: fadeInUp 1.5s ease-out forwards;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

.animate-fade-out {
  animation: fadeOut 0.5s ease-out forwards;
}

/* Effet Bounce */
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.animate-bounce {
  animation: bounce 2s infinite;
}

  
  </style>
  